var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.$style.main,
  _vm.isWaitResponse && _vm.$style.waitResponse
]},[_c('div',{class:[_vm.$style.time, !_vm.isRobot ? _vm.$style.right : '']},[_vm._v(" "+_vm._s(_vm._f("formatCalendarDateTime")(_vm.createTime))+" ")]),_c(_vm.component,{tag:"component",attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }